import {Component, OnInit, ViewChild} from '@angular/core';
import {Globals} from '../../globals';
import {PatientService} from '../../modules/patient/patient.service';
import {MedicalHistoryService} from '../../services/form/medical-history.service';
import {FormsService} from '../../modules/forms/forms.service';
import {NotesService} from '../../services/notes.service';
import {eRxService} from '../../modules/erx/erx.service';
import {PrescriptionListingModel} from '../../modules/erx/models';
import * as moment from 'moment';
import {PatientHistoryModel} from '../../modules/medical-history/models/patient-history.model';
import {
    ListMedicationHistoryModel,
    MedicationHistoryModel, MedicationRxHistoryModel
} from '../../modules/medical-history/models/medication-history.model';
import {MedicalHistoryModel} from '../../modules/medical-history/models/medical-history.model';
import {NoteDataModel} from '../../models/notes/note-data.model';
import {PatientDataModel} from '../../models/patient/patient-data.model';
import {TdoTableV2Component} from '../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {MatDialogRef} from '@angular/material/dialog';
import {MessagingService} from '../../services/messaging.service';
import {MessagingConstants} from '../../models/MessagingConstants';
import {TdoDropdownChange} from '../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {ConfigurationService} from '../../modules/configuration/configuration.service';
import {NoteCategoryEnum} from 'src/app/models/enum/note-category.enum';
import {NoteTypeEnum} from 'src/app/models/enum/note-type.enum';
import {DatePipe} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormsGlobals} from "../../models/forms/forms.enum";

@Component({
    selector: 'app-medical-history-dialog',
    templateUrl: './medical-history-dialog.component.html',
    styleUrls: ['./medical-history-dialog.component.scss']
})
export class MedicalHistoryDialogComponent implements OnInit {
    patientHistory: PatientHistoryModel;
    medicationHistory: MedicationHistoryModel[] = [];
    medicationRxHistory: MedicationRxHistoryModel[] = [];
    listMedicationHistory: ListMedicationHistoryModel[] = [];
    listMedicalHistory: ListMedicationHistoryModel[] = [];
    medicalHistory: MedicalHistoryModel[] = [];
    selectedMedicalHistory: ListMedicationHistoryModel;
    selectedMedicationHistory: ListMedicationHistoryModel;
    prescriptions: PrescriptionListingModel[] = [];
    patientName: string = '';
    formData: any;
    patientId: string = '';
    caseWorkItemFormsId: string = '';
    doctorNote: NoteDataModel[] = [];

    isLoading = true;
    isLoadingMedicationHistory = false;
    patients: PatientDataModel[] = [];

    P_explain = 'Please explain';

    @ViewChild('medicationTable') medicationTable: TdoTableV2Component;
    @ViewChild('medicalTable') medicalTable: TdoTableV2Component;
    @ViewChild('rxHistory') rxHistory: TdoTableV2Component;


    readonly NoteCategoryEnum = NoteCategoryEnum;
    readonly NoteTypeEnum = NoteTypeEnum;

    constructor(public globals: Globals,
                private messagingService: MessagingService,
                public dialogRef: MatDialogRef<MedicalHistoryDialogComponent>,
                public patientService: PatientService,
                public medService: MedicalHistoryService,
                public formService: FormsService,
                public noteService: NotesService,
                private eRxService: eRxService,
                private datePipe: DatePipe,
                private formsGlobals: FormsGlobals,
                private snackBar: MatSnackBar,
                public configurationService: ConfigurationService) {
    }

    ngOnInit(): void {
        this.patientId = this.globals.currentPatientId;
        this.getListMedicalHistory(true);
        this.getListMedicationHistory(true);
        this.getPastRx();
    }

    getListMedicalHistory(selectFirst: boolean) {
        this.medService.getListMedicalHistory(this.patientId).subscribe((medicationList) => {
            if (medicationList) {
                this.listMedicalHistory = medicationList.map(item => ({
                    DFormId: item.DFormId,
                    CaseWorkItemFormsId: item.CaseWorkItemFormsId,
                    StatusOn: item.StatusOn,
                    DFormName: item.DFormName,
                    enumFormCategoryID: item.enumFormCategoryID,
                    ItemDisplayValue: item.ItemDisplayValue,
                    display: `${item.DFormName} - ${item.ItemDisplayValue}: ${(item.StatusOn !== null ? this.datePipe.transform(item.StatusOn, 'shortDate') : '')}`
                }));

                if (selectFirst) {
                    this.selectedMedicalHistory = this.listMedicalHistory[0];
                    this.getMedicalHistory(this.selectedMedicalHistory);
                }
            }
        });
    }

    getListMedicationHistory(selectFirst: boolean) {
        this.medService.getListMedicationHistory(this.patientId).subscribe((medicationList) => {
            if (medicationList) {
                this.listMedicationHistory = medicationList.map(item => ({
                    DFormId: item.DFormId,
                    CaseWorkItemFormsId: item.CaseWorkItemFormsId,
                    StatusOn: item.StatusOn,
                    DFormName: item.DFormName,
                    enumFormCategoryID: item.enumFormCategoryID,
                    ItemDisplayValue: item.ItemDisplayValue,
                    display: `${item.ItemDisplayValue}: ${(item.StatusOn !== null ? this.datePipe.transform(item.StatusOn, 'shortDate') : '')}`
                }));
                if (selectFirst) {
                    this.selectedMedicationHistory = this.listMedicationHistory[0];
                    this.getMedHistory(this.selectedMedicationHistory);
                }
            }
        });
    }

    getMedHistory(medicationHistory: ListMedicationHistoryModel) {
        this.medService.getMedicationHistory(medicationHistory.CaseWorkItemFormsId).subscribe((medicationRes) => {
            this.isLoadingMedicationHistory = false;
            this.medicationHistory = medicationRes;
            this.updateMedicationTable();
        });
    }

    getPastRx() {
        this.eRxService.getPrescriptions(this.patientId).subscribe(
            (response: any[]) => {
                this.medicationRxHistory = response.map(item => {
                    const Medication = item.Medication !== undefined ? item.Medication : '';
                    const Dosage = item.Dosage !== undefined ? item.Dosage : '';
                    const DosageForm = item.DosageForm !== undefined ? item.DosageForm : '';
                    const DispenseQuantity = item.DispenseQuantity !== undefined ? item.DispenseQuantity : '';
                    const DispenseUnit = item.DispenseUnit !== undefined ? item.DispenseUnit : '';
                    const StartDate = item.RxDate !== undefined ? item.RxDate : '';
                    const Directions = item.Directions !== undefined ? item.Directions : '';
                    return {Medication, Dosage, DosageForm, DispenseQuantity, DispenseUnit, StartDate, Directions};
                });

                this.updateMedicationRxTable();
            },
            error => {
                console.log(error);
            }
        );
    }

    /* getMedHistoryObject() {
const formData = this.formData;
for (let i = 0; i < formData.medicationHistoryResults.length; i++) {
let newMed = {
  resMRXMedication: '',
  resMRXStppedTagingIt: null,
  resMRXLastTaken: null,
  resMRXReason: '',
  resMRXStartDate: null,
  resMRXFrequency: '',
  resMRXQuantity: ''
};
// names of meds
if (formData.medicationHistoryResults[i].ItemName === 'resMRXMedication') {
  newMed.resMRXMedication = formData.medicationHistoryResults[i].Result;
} else {
  newMed.resMRXMedication = '';
}
// quantities
if (formData.medicationHistoryResults[i].ItemName === 'resMRXQuantity') {
  newMed.resMRXQuantity = formData.medicationHistoryResults[i].Result;
} else {
  newMed.resMRXQuantity = '';
}
// frequencies
if (formData.medicationHistoryResults[i].ItemName === 'resMRXFrequency') {
  newMed.resMRXFrequency = formData.medicationHistoryResults[i].Result;
} else {
  newMed.resMRXFrequency = '';
}
// reasons
if (formData.medicationHistoryResults[i].ItemName === 'resMRXReason') {
  newMed.resMRXReason = formData.medicationHistoryResults[i].Result;
} else {
  newMed.resMRXReason = '';
}
// still taking
if (formData.medicationHistoryResults[i].ItemName === 'resMRXStppedTagingIt') {
  newMed.resMRXStppedTagingIt = formData.medicationHistoryResults[i].Result;
} else {
  newMed.resMRXStppedTagingIt = null;
}
// quantities
if (formData.medicationHistoryResults[i].ItemName === 'resMRXLastTaken') {
  newMed.resMRXLastTaken = formData.medicationHistoryResults[i].Result;
}else {
  newMed.resMRXLastTaken = null;
}
// quantities
if (formData.medicationHistoryResults[i].ItemName === 'resMRXStartDate') {
  newMed.resMRXStartDate = formData.medicationHistoryResults[i].Result;
}else {
  newMed.resMRXStartDate = null;
}
this.medicationHistory.push(newMed);
console.log(this.medicationHistory);
}
}*/

    onCancelClick() {
        this.dialogRef.close();
    }

    onOkClick() {
        this.dialogRef.close();
    }

    addMedication() {
        this.medService.AddMedication_MedicalForm(this.patientId, true).subscribe((res) => {
            this.showMessage('Success', 'Form(s) added');
            this.getListMedicationHistory(false);
            this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
        }, err => {
          this.showMessage('Error', 'Problem adding forms');
        });
    }

    addMedical() {
        this.medService.AddMedication_MedicalForm(this.patientId, false).subscribe((res) => {
            this.showMessage('Success', 'Form(s) added');
            this.getListMedicalHistory(false);
            this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
        }, err => {
          this.showMessage('Error', 'Problem adding forms');
        });
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    updateMedicationTable() {
        this.medicationTable.updateData(this.medicationHistory);
    }

    updateMedicationRxTable() {
        this.rxHistory.updateData(this.medicationRxHistory);
    }

    onChangeMedicalHistory(e: TdoDropdownChange) {
        if (!e.isUserInput) {
            return;
        }
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.getMedicalHistory(e.value);
                    return;
                } else {
                    //
                    const oldLoc = this.selectedMedicalHistory;
                    this.selectedMedicalHistory = null;
                    setTimeout(() => {
                        this.selectedMedicalHistory = oldLoc;
                    }, 10);
                }
            });
        } else {
            this.getMedicalHistory(e.value);
        }
    }

    onChangeMedicationHistory(e: TdoDropdownChange) {
        if (!e.isUserInput) {
            return;
        }
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.getMedHistory(e.value);
                    return;
                } else {
                    //
                    const oldLoc = this.selectedMedicalHistory;
                    this.selectedMedicalHistory = null;
                    setTimeout(() => {
                        this.selectedMedicalHistory = oldLoc;
                    }, 10);
                }
            });
        } else {
            this.getMedHistory(e.value);
        }
    }

    getMedicalHistory(medicalHistory: ListMedicationHistoryModel) {
        this.medicalHistory = [];
        this.medService.getMedicalHistory(medicalHistory.CaseWorkItemFormsId).subscribe(res => {
            if (res.medicalHistoryResults) {
                let i = 0;
                for (const item of res.medicalHistoryResults) {
                    const model = new MedicalHistoryModel();
                    model.resultid = item.resultid;
                    if (item.enumFormControlID === this.formsGlobals.CONTROL_TEXT_BOX  && item.ItemOrder !== 2) { // question
                        model.problem = item.problem;
                        model.patientNote = item.patientNote;
                        model.ItemOrder = item.ItemOrder;
                        this.medicalHistory.push(model);
                        i++;
                    } else if (item.enumFormControlID === this.formsGlobals.CONTROL_TEXT_BOX && item.problem !== this.P_explain) { // any comment
                        model.problem = item.problem;
                        model.patientNote = item.patientNote;
                        model.ItemOrder = item.ItemOrder;
                        this.medicalHistory.push(model);
                        i++;
                    } else if (item.enumFormControlID === this.formsGlobals.CONTROL_RADIO_LIST) {// yes / no check
                        model.problem = item.problem;
                        model.patientNote = '';
                        model.ItemOrder = item.ItemOrder;
                        this.medicalHistory.push(model);
                        i++;
                    } else if (item.enumFormControlID === this.formsGlobals.CONTROL_CHECK_BOX) {// check
                        model.problem = item.problem;
                        model.patientNote = '';
                        model.ItemOrder = item.ItemOrder;
                        this.medicalHistory.push(model);
                        i++;
                    } else if (item.enumFormControlID === this.formsGlobals.CONTROL_TEXT_BOX && item.ItemOrder === 2) { // please explain
                        if (this.medicalHistory[i - 1].ItemOrder === 1 && this.medicalHistory[i - 1].validvalueId !== null) {
                            model.patientNote = item.patientNote;
                            model.ItemOrder = item.ItemOrder;
                            this.medicalHistory[i - 1].patientNote = item.patientNote;
                        }
                    } else if (item.enumFormControlID === this.formsGlobals.CONTROL_DATE && item.ItemOrder !== 2) { // Date
                        model.problem = item.problem;
                        model.patientNote = item.patientNote !== null ? this.datePipe.transform(item.patientNote, 'shortDate') : '';
                        model.ItemOrder = item.ItemOrder;
                        this.medicalHistory.push(model);
                        i++;
                    }
                }
            } else {
                this.medicalHistory = [];
            }
            this.medicalTable.updateData(this.medicalHistory);
        });

    }


}
